import React, { Component } from "react"

import LoadingSpinner from "../loading-spinner"
import GalleryCard from "./gallery-card"
import GalleryEndpoints from "./gallery-data"
import GoldPortWriting from "../../assets/data/writingPortsGold"
import GoldPortSilverDistinctWriting from "../../assets/data/writingPortsSilverDistinction"
import { random } from "lodash"

let randomPage = 1

const writingColorArray = [
  "rgba(69, 148, 61, 1)",
  "rgba(243, 120, 54, 1)",
  "rgba(229, 81, 45, 1)",
  "rgba(46, 146, 153, 1)",
  "rgba(46, 147, 154, 1)",
  "rgba(44, 132, 201, 1)"
]

const ART_CATEGORIES = [
  "Architecture & Industrial Design",
  "Painting",
  "Sculpture",
  "Digital Art"
];

const WRITING_CATEGORIES = [
  "Poetry",
  "Short Story",
  "Essay"
];


export default class GalleryGrid extends Component {
  state = {
    loading: false,
    works: [],
    page: 1, // actual res
    total_pages: 1, // init only
    perPage: "",
    hasNextPage: "",
    hasPrevPage: "",
    year: 2025
  }

  getWorks = async query =>
    await fetch(process.env.GATSBY_ORS_GALLERY + query)
      .then(res => res.json())
      .catch(error => console.log("error", error))

  getPortalWorks = async query => {
    try {
      let extension = query.length === 0 ? `?page=${this.state.page}&perPage=8`: query;
      if(!extension.includes(`&grm.page=`)) {
        extension += `&grm.page=${this.state.page}`;
      }

      console.log("query = ", query);
      console.log("extension = ", extension);
      const res = await fetch(process.env.GATSBY_PORTAL_GALLERY + extension);
      const data = await res.json();
      return data; // Returning data so you can use it later
    } catch (error) {
      console.log("portal gallery error", error);
    }
  }

  async fetchPortalWorks() {
    // console.log('in fetchPortalWorks');
    try {
        let res = await this.getPortalWorks("");
        let onlyPortalWorks = res?.works || [];

        let portalWritingWorks = onlyPortalWorks.filter(work => work.isWriting);
        let portalArtWorks = onlyPortalWorks.filter(work => work.isArt);

        portalArtWorks = portalArtWorks.map(art => ({
          ...art,
          thumbUrl: art.thumbUrlXLarge || art.thumbUrl,
        }));

        portalArtWorks = this.updateThumbUrls(portalArtWorks);
      
        portalWritingWorks = portalWritingWorks.map(writing => ({
          ...writing,
          excerpt: typeof writing.excerpt === "string" ? this.extractExcerpt(writing.excerpt, 50) : writing.excerpt
        }));

        let finalPortalWorks = [];
        let maxLength = Math.max(portalArtWorks.length, portalWritingWorks.length);

        for (let i = 0; i < maxLength; i++) {
            if (portalArtWorks[i]) finalPortalWorks.push(portalArtWorks[i]);
            if (portalWritingWorks[i]) finalPortalWorks.push(portalWritingWorks[i]);
        }

        this.setState({ 
          works: finalPortalWorks, 
          loading: false, 
          page: res.pagination.page, 
          hasNextPage: res.pagination.hasNextPage,
          hasPrevPage: res.pagination.page === 1 ? false : true,
          total_pages: res.pagination.totalPages
         });

    } catch (error) {
        console.error("Error in fetchPortalWorks:", error);
        this.setState({ loading: false });
    }
  }

  // helpers
  updateThumbUrls = (works) => {

  const updatedWorks = works.map(work => {

    if (work.thumbUrlXLarge) {
      work.thumbUrl = work.thumbUrlXLarge; // Update the thumbUrl
    } else {
      // console.log(`No thumbUrlXLarge found for work with ID ${work.id}`);
    }
      return work;
    });

    return updatedWorks;
  };

  getCategoryPrefix = (category) => {
    if (ART_CATEGORIES.includes(category)) return "art";
    if (WRITING_CATEGORIES.includes(category)) return "writing";
    return ""; // Default case if category is unknown
  };

  extractExcerpt = (html, charLimit) => {
    const text = html.replace(/<[^>]*>/g, ''); // Strip out HTML tags
    return `${text.slice(0, charLimit)}...`; // Return sliced excerpt
  };

  // testing combined prev & next
  handlePageChange = async (direction) => {
    console.log('this.props', this.props);
    console.log('this.state', this.state);
    let portalQuery = '';
    console.log('this.state.page = ', this.state.page);

    let newPage = this.state.page + (direction === "next" ? 1 : -1);
  
    // Prevent invalid page requests
    if ((direction === "next" && !this.state.hasNextPage) || 
        (direction === "prev" && !this.state.hasPrevPage)) {
      // console.log("No more pages in this direction.");
      return;
    }
    if(this.props.year < 2024) {
      this.setState({ loading: true }, async () => {
      try {
        let query = encodeURIComponent(this.props.query);
        const portalQuery = `?grm.year=${this.props.year}&grm.query=${query}&grm.page=${newPage}`;
    
        console.log("Fetching ORS page:", portalQuery);
    
        const res = await fetch(process.env.GATSBY_ORS_GALLERY + portalQuery);
        const resJson = await res.json();
    
        console.log("ORS pagination:", resJson.pagination);
    
        this.setState({
          works: resJson.works,
          page: resJson.pagination.page,
          total_pages: resJson.pagination.totalPages,
          hasNextPage: resJson.pagination.hasNextPage,
          hasPrevPage: resJson.pagination.page > 1,
          loading: false
        });
      } catch (error) {
        console.error("Error fetching ORS paginated results:", error);
        this.setState({ loading: false });
      }
    });
      
    } else {
      if ((this.props.category && this.props.query && this.props.workType && this.props.year)) {
        let query = encodeURIComponent(this.props.query);
    
        portalQuery = `${this.props.workType}?&grm.year=${this.props.year}&grm.${this.props.workType}=${query}&grm.page=${newPage}`;
      } else if ( (this.props.query && this.props.year)) {
        let query = encodeURIComponent(this.props.query);
    
        portalQuery = `search?&grm.year=${this.props.year}&grm.query=${query}&grm.page=${newPage}`;
        console.log(`search query`, portalQuery);
      }
        
        this.setState({ loading: true }, async () => {
          try {
            console.log(`in setState handlePageChange`)
            const res = await this.getPortalWorks(portalQuery);
    
            let resArt = res.works.filter(work => work.isArt);
            let resWrit = res.works.filter(work => work.isWriting);
    
            const updatedArtWorks = this.updateThumbUrls(resArt);
            const updatedWritWorks = resWrit.map(writing => ({
              ...writing,
              excerpt: typeof writing.excerpt === "string" ? this.extractExcerpt(writing.excerpt, 50) : writing.excerpt
            }));
    
            this.setState({
              works: [...updatedArtWorks, ...updatedWritWorks],
              page: res.pagination.page,
              total_pages: res.pagination.totalPages,
              hasNextPage: res.pagination.hasNextPage,
              hasPrevPage: res.pagination.page > 1,
              loading: false,
            });
    
          } catch (error) {
            console.error(`Error fetching ${direction} page`, error);
            this.setState({ loading: false });
          }
        });
    }
  };

  GenerateGrid = () => {
    // console.log(`in generate GRID`)
    this.setState({ loading: true }, () => {

      // portal section
      let portalQuery = "";
      const portalWorks = [];
     
      let galleryQuery = ""
      const worksArray = []
      if (this.props.category) {
        const concatCat = this.props.category.split(" ").join("")
      
        galleryQuery =
            `?grm.${this.props.workType}=${this.props.query}&grm.year=2023&grm.page=` +
          String(randomPage)

        fetch(process.env.GATSBY_ORS_GALLERY + galleryQuery)
          .then(response => response.json())
          .then(responseJson => {
     
            let i = 0
            for (i = 0; i < responseJson.works.length; i++) {
              worksArray.push(responseJson.works[i])
            }

            this.setState({ works: worksArray, loading: false })
          })

          .then((randomPage += 1))
          .catch(error => {
            console.log("error", error)
          })
      } else if (this.props.year) {
        console.log(`generate grid - else if year - 315`)
        galleryQuery =
          `/random?r.art_number=8&r.writing_number=8&r.year=${this.props.year}&r.page=` +
          String(randomPage)

        fetch(process.env.GATSBY_ORS_GALLERY + galleryQuery)
          .then(response => response.json())
          .then(responseJson => {
    
            let i = 0
            for (i = 0; i < 2; i++) {
              worksArray.push(responseJson.arts.works[i])
              worksArray.push(responseJson.writings.works[i])
            }
            for (i = 2; i < 4; i++) {
              worksArray.push(responseJson.writings.works[i])
              worksArray.push(responseJson.arts.works[i])
            }
            for (i = 4; i < 6; i++) {
              worksArray.push(responseJson.arts.works[i])
              worksArray.push(responseJson.writings.works[i])
            }
            for (i = 6; i < 8; i++) {
              worksArray.push(responseJson.writings.works[i])
              worksArray.push(responseJson.arts.works[i])
            }
     

            this.setState({ works: worksArray, loading: false })
          })

          .then((randomPage += 1))
          .catch(error => {
            console.log("error", error)
          })
      } else {
          this.getPortalWorks(`?page=${this.state.page + 1}&perPage=8`).then(res => {
            if (res && res.works) {
              const queryPortalWorks = res.works;
            const portalArtQuery = queryPortalWorks.filter(work => work.isArt);
            const portalWritQuery = queryPortalWorks.filter(work => work.isWriting);
            const artImageArr = this.updateThumbUrls(portalArtQuery);
            const writArr = portalWritQuery.map(writing => ({
              ...writing,
              excerpt: typeof writing.excerpt === "string" ? this.extractExcerpt(writing.excerpt, 50) : writing.excerpt
            }));
            
            const maxLength = writArr.length > artImageArr.length ? writArr.length : artImageArr.length;
            let fixedWorks = [];
            for(let i = 0; i < maxLength; i++) {
              if(writArr[i]) fixedWorks.push(writArr[i]);
              if(artImageArr[i]) fixedWorks.push(artImageArr[i]);
            }
              
              this.setState({ 
                works: fixedWorks, 
                page: res.pagination.page, 
                hasNextPage: res.pagination.hasNextPage,
                hasPrevPage: res.pagination.hasPreviousPage,
                loading: false
              })
            } else {
              console.log("error, generate grid else");
            }
          })

      }
    })
  }

  // attempt async to delay loading until ors and portal works retrieved
  async componentDidMount() {

    this.setState({ loading: true }, () => {


      const portalArr = []

      let portalQuery = "";

      const worksArray = []

      let galleryQuery = ""


      const awardQueries = ['GOLD', 'SILVER', 'VISIONS', 'VOICES', 'HERBLOCK', 'NYLIFE', 
        'FLAUNT', 'BIGA', 'BIGW',
        'GOLD&grm.workType=PORTFOLIO&grm.categoryType=ART',
        'GOLD&grm.workType=PORTFOLIO&grm.categoryType=WRITING',
        'SILVER&grm.workType=PORTFOLIO&grm.categoryType=ART',
        'SILVER&grm.workType=PORTFOLIO&grm.categoryType=WRITING']

      let queryYear = this.props.year ? this.props.year : 2025

       if (this.props.category && awardQueries.includes(this.props.query)) {
        portalQuery = `awards?&grm.year=${queryYear}&grm.awards=${this.props.query}&grm.page=${this.state.page}`
      } else if (this.props.year && this.props.query) {
        
        if(this.props.category === this.props.query) {
          const prefix = this.getCategoryPrefix(this.props.query);
          const query = encodeURIComponent(this.props.query);
          portalQuery = `${this.props.workType}?&grm.year=${queryYear}&grm.${this.props.workType}=${query}&grm.page=1`
        }else if(this.props.year === '2024' || this.props.year === '2025') {
          portalQuery = `search?&grm.year=${this.props.year}&grm.query=${this.props.query}&grm.page=1`
        } else {
          galleryQuery = `?&grm.year=${queryYear}&grm.query=${this.props.query}`;
        }

      } else {
        galleryQuery = GalleryEndpoints.galleryRandom
      }
      if(this.props.query && this.props.year) {
        if(this.props.year === '2024' || this.props.year === '2025') {
          this.getPortalWorks(portalQuery).then(res => {
            const queryPortalWorks = res.works;
            const portalArtQuery = queryPortalWorks.filter(work => work.isArt);
            const portalWritQuery = queryPortalWorks.filter(work => work.isWriting);
            const artImageArr = this.updateThumbUrls(portalArtQuery);

            const writArr = portalWritQuery.map(writing => ({
              ...writing,
              excerpt: typeof writing.excerpt === "string" ? this.extractExcerpt(writing.excerpt, 50) : writing.excerpt
            }));
            
            let maxLength = Math.max(artImageArr.length, writArr.length);
            let fixedWorks = [];

            for (let i = 0; i < maxLength; i++) {
                if (artImageArr[i]) fixedWorks.push(artImageArr[i]);
                if (writArr[i]) fixedWorks.push(writArr[i]);
            }
            this.setState({ 
              works: fixedWorks, 
              year: this.props.year ? this.props.year : 2025,
              page: res.pagination.page, 
              total_pages: res.pagination.totalPages, 
              perPage: res.pagination.perPage,
              hasNextPage: res.pagination.page < res.pagination.totalPages ? true : false,
              hasPrevPage: res.pagination.page === 1 ? false : true,
              loading: false });
          })

        } else {
          console.log(`ors year time`)
          let orsQuery = galleryQuery;

    console.log(`orsQuery = `, orsQuery);
          this.getWorks(orsQuery).then(res => {
            this.setState({ 
              works: res.works, 
              page: res.pagination.page,
              total_pages: res.pagination.totalPages,
              hasNextPage: res.pagination.hasNextPage,
              hasPrevPage: res.pagination.hasPreviousPage,
              year: this.props.year,
              loading: false 
            })
          })
        }
      } else if(this.props.category) {
        console.log('wait this section is necessary 446')
        } else if (this.props.year === '2024') {
          console.log('pull portal works 2024!');
        }
        else {
          this.fetchPortalWorks();
      }
    })
  }

  render() {
    const { GenerateGrid } = this.props
    const { nextPage } = this.state.hasNextPage;
    const { prevPage } = this.state.hasPrevPage;

    return (
      <section >
        <div className="gallery-widget">

{/* <h3 class="alert" id="alert">🚧  The gallery is currently unavailable due to technical maintenance 🚧 <br />
           Thank you for your patience.</h3> */}

          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <ul>
              {this.state.works.map((work, index) => {
                const writingColor = 
                  writingColorArray[
                    Math.floor(Math.random() * writingColorArray.length)
                  ]

                return (
                  <GalleryCard
                    key={work.id}
                    work={work}
                    writingColor={writingColor}
                  />
                )
              })}
            </ul>
          )}

          {/* TESTING */}
          <div className="pagination">
          {
          (
            <>
              {/* Show "Previous" only if not 1st page */}
              {this.state.hasPrevPage && (
                <a href="#" className="button" onClick={() => this.handlePageChange("prev")}>
                  Previous
                </a>
              )}

              <p>
                Page <span>{this.state.page}</span> of <span>{this.state.total_pages}</span>
              </p>


              {/* "Next" only if more pages */}
              {this.state.hasNextPage && (
                <a href="#" className="button" onClick={() => this.handlePageChange("next")}>
                  Next
                </a>
              )}
            </>
          )}
        </div>
        </div>
      </section>
    )
  }
}